const DEFAULT_COLLISION_PADDING = 16;
const CONTENT_MIN_WIDTH = 260;

export { CONTENT_MIN_WIDTH, DEFAULT_COLLISION_PADDING };
//# sourceMappingURL=constants.mjs.map
